import { render, staticRenderFns } from "./settings-user-mapping-pane.vue?vue&type=template&id=0f3b7c6a&scoped=true"
import script from "./settings-user-mapping-pane.vue?vue&type=script&lang=js"
export * from "./settings-user-mapping-pane.vue?vue&type=script&lang=js"
import style0 from "./settings-user-mapping-pane.vue?vue&type=style&index=0&id=0f3b7c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3b7c6a",
  null
  
)

export default component.exports